import { StoreAction, XmAction } from 'store/actions';
import { HeroBannerInfo } from './models';

export function heroBannerReducer(state: HeroBannerInfo, action: XmAction<HeroBannerInfo>): HeroBannerInfo {
    switch (action.type) {
        case StoreAction.GET_HERO_BANNER_INFO:
        case StoreAction.CLEAR_HERO_BANNER_INFO:
            return action.payload;
        default:
            return state;
    }
}
